import {Injectable} from '@angular/core';
import {AbstractControl, AsyncValidator, ValidationErrors} from '@angular/forms';
import {Observable, of} from 'rxjs';
import {RegistrationDataValidationService} from '../services/registration-data-validation.service';
import {ValidationErrorResponse, 
        ValidationError, 
        UNIQUE_VALIDATION_ERROR_CODE,
        BLACKLISTED_IN_PASSWORD_ERROR_CODE,
        MONTH_IN_PASSWORD_ERROR_CODE,
        WEEKDAY_IN_PASSWORD_ERROR_CODE,
        SPECIAL_CHARS_IN_PASSWORD_ERROR_CODE
        } from '../../shared/models/validation-error-response';
import {catchError, map} from 'rxjs/operators';

@Injectable({ providedIn: 'root' })
export class UsernameAsyncValidator implements AsyncValidator {

  constructor(public registrationDataValidationService: RegistrationDataValidationService) {}

  validate(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.registrationDataValidationService.validateUsername(ctrl.value).pipe(
      map((validationResponse: ValidationErrorResponse) => {
        if (!validationResponse?.errors) {
          console.log('No errors in the response. Form Valid.');
          return null;
        }

        const validationErrors: ValidationErrors = {};
        validationResponse?.errors.forEach((v: ValidationError) => {
          if (v.code === UNIQUE_VALIDATION_ERROR_CODE) {
            validationErrors.uniqueUsername = true;
          } else {
            // keeping other validation errors, just in case we missed some validation on frontend side
            validationErrors[v.code] = true;
            console.log('Detected non UNIQUE validation error, returned from the server. ' +
              'Means the input is still invalid, and not handled properly by frontend validators. ' +
              'Input username value: ' + ctrl.value + '. Validation error: ' + JSON.stringify(v));
          }
        });
        return validationErrors;
      }),
      catchError(err => {
        console.error('Server returned unexpected error while validating username. Message: ' + err);
        return of({unexpectedError: true});
      })
    );
  }

  validatePasswordErrors(ctrl: AbstractControl): Promise<ValidationErrors | null> | Observable<ValidationErrors | null> {
    return this.registrationDataValidationService.validatePassword(ctrl.value).pipe(
      map((validationResponse: ValidationErrorResponse) => {
        if (!validationResponse?.errors) {
          console.log('No errors in the response. Form Valid.');
          return null;
        }

        const validationErrors: ValidationErrors = {};
        validationResponse?.errors.forEach((v: ValidationError) => {
          if (v.code === BLACKLISTED_IN_PASSWORD_ERROR_CODE) {
            validationErrors.blacklistedPassword = true;
          } else if (v.code === MONTH_IN_PASSWORD_ERROR_CODE) {
            validationErrors.containsMonth = true;
          } else if (v.code === WEEKDAY_IN_PASSWORD_ERROR_CODE) {
            validationErrors.containsWeekDay = true;
          } else if (v.code === SPECIAL_CHARS_IN_PASSWORD_ERROR_CODE) {
            validationErrors.containsChar = true;
          } else {
            // keeping other validation errors, just in case we missed some validation on frontend side
            validationErrors[v.code] = true;
            console.log('Detected non UNIQUE validation error, returned from the server. ' +
              'Means the input is still invalid, and not handled properly by frontend validators. ' +
              'Input password value: ' + ctrl.value + '. Validation error: ' + JSON.stringify(v));
          }
        });
        return validationErrors;
      }),
      catchError(err => {
        console.error('Server returned unexpected error while validating password. Message: ' + err);
        return of({unexpectedError: true});
      })
    );
  }

}
